import React from 'react';
import TabPanel from 'components/coaching/widgets/TabPanel';
import ExecCoachingManagerRollupContainer from 'components/dashboard/admin/ExecCoachingManagerRollupContainer';
import CoachingPlansWidgetContainer from 'components/dashboard/CoachingPlansWidgetContainer';
import './AdminDashCoaching.styl';
import CoachingPlanStore from 'stores/coaching/CoachingPlanStore';
import connectToStores from 'alt-utils/lib/connectToStores';
import AuthStore from 'stores/AuthStore';
import {loadUpcomingReviewData} from 'components/dashboard/UpcomingCoachingAgenda';
import CoachingPlanSource from 'sources/coaching/CoachingPlanSource';
import {getQuery} from 'utils/getQueryParam';
import {shouldUpdate} from 'components/StatsPage2.utils';

export const MY_COACHING_TAB_INDEX = 1;

@connectToStores
export default class AdminDashCoaching extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasPlans: undefined,
    };
  }

  static getStores() {
    return [AuthStore, CoachingPlanStore];
  }

  static getPropsFromStores() {
    const {user: authUser} = AuthStore.getState();

    return {
      userPlans: CoachingPlanStore.getState().planMap.filter(p => p.coach.id === authUser.id),
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (shouldUpdate(prevProps, this.props, false, false, true)) {
      this.loadData();
    }
  }

  loadData() {
    const {user: authUser} = AuthStore.getState();

    CoachingPlanSource.fetchAll({
      coachId: authUser.id,
      includeCompleted: true,
      includeReviews: true,
    }).then(rslt => this.setState({hasPlans: !rslt.isEmpty()}));
  }

  render() {
    const {location, coachId} = this.props;
    const {hasPlans} = this.state;

    const query = getQuery(location);
    const selectedCoachId = query.coachId;

    let panels = [
      <ExecCoachingManagerRollupContainer {...this.props} selectedCoachId={selectedCoachId} />,
    ];
    hasPlans &&
      panels.push(
        <CoachingPlansWidgetContainer
          {...this.props}
          managerId={this.props.adminId}
          manager={this.props.admin}
          suppressToggle
          refreshUpcomingReviews={() =>
            loadUpcomingReviewData(AuthStore.getState().user.id, coachId)
          }
        />
      );

    let tabs = ['All Coaching'];
    // Make sure to update the const MY_COACHING_TAB_INDEX if the order change or a new tab is added
    hasPlans && tabs.push('My Coaching');
    const defaultSelectedIdx = query.tabIndex != null ? parseInt(query.tabIndex) : 0;

    return (
      <div className="admin-dash-coaching">
        <TabPanel
          defaultSelectedIdx={defaultSelectedIdx}
          title=""
          panels={panels}
          tabs={tabs}
          wrapperClassName={'admin-dash-panel-wrapper'}
        />
      </div>
    );
  }
}
